import type { ProcessingResult, UnresolvedVisualIdentity } from '@/types/document-types';

export interface PublicDocumentOutcomes {
  documents: Array<Pick<ProcessingResult, 'id' | 'documentId' | 'storageDocumentId' | 'fileName' | 'status' | 'error' | 'unresolvedVisualIdentities'> & { entities?: ProcessingResult['entities'] }>;
  processingErrors: string[];
  stage: 'complete' | 'error';
}

// The server builds and saves these outcomes; the browser only reads them back.
export function restoreDocumentOutcomes(snapshot: any, orderId: string): { results: ProcessingResult[]; processingErrors: string[]; stage: 'complete' | 'error' | 'idle' } {
  const saved: PublicDocumentOutcomes | undefined = snapshot.publicDocumentOutcomes;
  const legacy = snapshot.processingOutcome;
  const known = saved?.documents ?? (legacy?.documentId ? [legacy] : []);
  const preserved = snapshot.extendedData?.preservedDocumentDetails?.documents || [];
  const sources: string[] = snapshot.metadata?.sourceFiles || [];
  const documents = known.length ? known : sources.map((fileName, index) => {
    const matches = preserved.filter((document: any) => document.fileName === fileName || document.documentId === fileName);
    return { id: `${orderId}-${index}`, documentId: matches.length === 1 ? matches[0].documentId : '', fileName, status: 'unknown' };
  });
  return {
    results: documents.map((document: any, index: number) => {
      const matches = preserved.filter((item: any) => document.documentId
        ? item.documentId === document.documentId
        : item.fileName === document.fileName);
      const details = matches.length === 1 ? matches[0] : undefined;
      return {
        id: document.id || `${orderId}-${index}`, documentId: document.documentId || '', storageDocumentId: document.storageDocumentId || document.document?.id,
        fileName: document.fileName || sources[index], status: document.status || 'unknown',
        error: document.error, unresolvedVisualIdentities: document.unresolvedVisualIdentities as UnresolvedVisualIdentity[] | undefined,
        humanIdentityReviews: document.humanIdentityReviews,
        entities: document.entities || [], processingTime: 0,
        documentCategory: details?.documentType || 'unknown', documentMetadata: details?.documentMetadata,
        documentSpecificDetails: details?.documentSpecificDetails, transactionDetails: details?.transactionDetails,
        shippingDetails: details?.shippingDetails, fileType: details?.contentType || 'application/octet-stream'
      };
    }),
    processingErrors: saved?.processingErrors ?? (legacy?.error ? [legacy.error] : []),
    stage: saved?.stage ?? (legacy ? (legacy.status === 'failed' ? 'error' : 'complete') : 'idle')
  };
}
